// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/attachments.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.attachments";

/** Enum for attachment types */
export enum AttachmentType {
  UNKNOWN_ATTACHMENT_TYPE = 0,
  /** DOCUMENT - PDF, DOCX, MD, TXT files */
  DOCUMENT = 1,
  JIRA_ISSUE = 2,
  LINEAR_ISSUE = 3,
  /** IMAGE - JPEG, PNG image files */
  IMAGE = 4,
  LINEAR_PROJECT = 5,
  /** DOCUMENT_LINK - DB-backed document reference (no GCS object) */
  DOCUMENT_LINK = 6,
  /** URL - Scraped webpage URL reference (no file stored) */
  URL = 7,
  /** SPREADSHEET - CSV, XLSX files */
  SPREADSHEET = 8,
  /** EXTERNAL_DOCUMENT - Provider-backed workspace document (Drive/Notion/Confluence) */
  EXTERNAL_DOCUMENT = 9,
}

export function attachmentTypeFromJSON(object: any): AttachmentType {
  switch (object) {
    case 0:
    case "UNKNOWN_ATTACHMENT_TYPE":
      return AttachmentType.UNKNOWN_ATTACHMENT_TYPE;
    case 1:
    case "DOCUMENT":
      return AttachmentType.DOCUMENT;
    case 2:
    case "JIRA_ISSUE":
      return AttachmentType.JIRA_ISSUE;
    case 3:
    case "LINEAR_ISSUE":
      return AttachmentType.LINEAR_ISSUE;
    case 4:
    case "IMAGE":
      return AttachmentType.IMAGE;
    case 5:
    case "LINEAR_PROJECT":
      return AttachmentType.LINEAR_PROJECT;
    case 6:
    case "DOCUMENT_LINK":
      return AttachmentType.DOCUMENT_LINK;
    case 7:
    case "URL":
      return AttachmentType.URL;
    case 8:
    case "SPREADSHEET":
      return AttachmentType.SPREADSHEET;
    case 9:
    case "EXTERNAL_DOCUMENT":
      return AttachmentType.EXTERNAL_DOCUMENT;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AttachmentType");
  }
}

export function attachmentTypeToJSON(object: AttachmentType): string {
  switch (object) {
    case AttachmentType.UNKNOWN_ATTACHMENT_TYPE:
      return "UNKNOWN_ATTACHMENT_TYPE";
    case AttachmentType.DOCUMENT:
      return "DOCUMENT";
    case AttachmentType.JIRA_ISSUE:
      return "JIRA_ISSUE";
    case AttachmentType.LINEAR_ISSUE:
      return "LINEAR_ISSUE";
    case AttachmentType.IMAGE:
      return "IMAGE";
    case AttachmentType.LINEAR_PROJECT:
      return "LINEAR_PROJECT";
    case AttachmentType.DOCUMENT_LINK:
      return "DOCUMENT_LINK";
    case AttachmentType.URL:
      return "URL";
    case AttachmentType.SPREADSHEET:
      return "SPREADSHEET";
    case AttachmentType.EXTERNAL_DOCUMENT:
      return "EXTERNAL_DOCUMENT";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AttachmentType");
  }
}

export enum ExternalDocumentProvider {
  UNKNOWN_EXTERNAL_DOCUMENT_PROVIDER = 0,
  GOOGLE_DRIVE = 1,
  NOTION = 2,
  CONFLUENCE = 3,
}

export function externalDocumentProviderFromJSON(object: any): ExternalDocumentProvider {
  switch (object) {
    case 0:
    case "UNKNOWN_EXTERNAL_DOCUMENT_PROVIDER":
      return ExternalDocumentProvider.UNKNOWN_EXTERNAL_DOCUMENT_PROVIDER;
    case 1:
    case "GOOGLE_DRIVE":
      return ExternalDocumentProvider.GOOGLE_DRIVE;
    case 2:
    case "NOTION":
      return ExternalDocumentProvider.NOTION;
    case 3:
    case "CONFLUENCE":
      return ExternalDocumentProvider.CONFLUENCE;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ExternalDocumentProvider");
  }
}

export function externalDocumentProviderToJSON(object: ExternalDocumentProvider): string {
  switch (object) {
    case ExternalDocumentProvider.UNKNOWN_EXTERNAL_DOCUMENT_PROVIDER:
      return "UNKNOWN_EXTERNAL_DOCUMENT_PROVIDER";
    case ExternalDocumentProvider.GOOGLE_DRIVE:
      return "GOOGLE_DRIVE";
    case ExternalDocumentProvider.NOTION:
      return "NOTION";
    case ExternalDocumentProvider.CONFLUENCE:
      return "CONFLUENCE";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ExternalDocumentProvider");
  }
}

/**
 * Per-item background processing state for an attachment.
 * Used by the background intake flow to surface in-progress / failed items
 * on the project page and to gate the per-item retry path.
 */
export enum AttachmentProcessingStatus {
  UNKNOWN_ATTACHMENT_PROCESSING_STATUS = 0,
  ATTACHMENT_PENDING = 1,
  ATTACHMENT_PROCESSING = 2,
  ATTACHMENT_READY = 3,
  ATTACHMENT_FAILED = 4,
}

export function attachmentProcessingStatusFromJSON(object: any): AttachmentProcessingStatus {
  switch (object) {
    case 0:
    case "UNKNOWN_ATTACHMENT_PROCESSING_STATUS":
      return AttachmentProcessingStatus.UNKNOWN_ATTACHMENT_PROCESSING_STATUS;
    case 1:
    case "ATTACHMENT_PENDING":
      return AttachmentProcessingStatus.ATTACHMENT_PENDING;
    case 2:
    case "ATTACHMENT_PROCESSING":
      return AttachmentProcessingStatus.ATTACHMENT_PROCESSING;
    case 3:
    case "ATTACHMENT_READY":
      return AttachmentProcessingStatus.ATTACHMENT_READY;
    case 4:
    case "ATTACHMENT_FAILED":
      return AttachmentProcessingStatus.ATTACHMENT_FAILED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AttachmentProcessingStatus");
  }
}

export function attachmentProcessingStatusToJSON(object: AttachmentProcessingStatus): string {
  switch (object) {
    case AttachmentProcessingStatus.UNKNOWN_ATTACHMENT_PROCESSING_STATUS:
      return "UNKNOWN_ATTACHMENT_PROCESSING_STATUS";
    case AttachmentProcessingStatus.ATTACHMENT_PENDING:
      return "ATTACHMENT_PENDING";
    case AttachmentProcessingStatus.ATTACHMENT_PROCESSING:
      return "ATTACHMENT_PROCESSING";
    case AttachmentProcessingStatus.ATTACHMENT_READY:
      return "ATTACHMENT_READY";
    case AttachmentProcessingStatus.ATTACHMENT_FAILED:
      return "ATTACHMENT_FAILED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AttachmentProcessingStatus");
  }
}

export enum CompanyContextSection {
  COMPANY_CONTEXT_SECTION_UNSPECIFIED = 0,
  COMPANY_CONTEXT_SECTION_COMPANY_GOALS = 1,
  COMPANY_CONTEXT_SECTION_ONBOARDING_BACKGROUND = 2,
}

export function companyContextSectionFromJSON(object: any): CompanyContextSection {
  switch (object) {
    case 0:
    case "COMPANY_CONTEXT_SECTION_UNSPECIFIED":
      return CompanyContextSection.COMPANY_CONTEXT_SECTION_UNSPECIFIED;
    case 1:
    case "COMPANY_CONTEXT_SECTION_COMPANY_GOALS":
      return CompanyContextSection.COMPANY_CONTEXT_SECTION_COMPANY_GOALS;
    case 2:
    case "COMPANY_CONTEXT_SECTION_ONBOARDING_BACKGROUND":
      return CompanyContextSection.COMPANY_CONTEXT_SECTION_ONBOARDING_BACKGROUND;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum CompanyContextSection");
  }
}

export function companyContextSectionToJSON(object: CompanyContextSection): string {
  switch (object) {
    case CompanyContextSection.COMPANY_CONTEXT_SECTION_UNSPECIFIED:
      return "COMPANY_CONTEXT_SECTION_UNSPECIFIED";
    case CompanyContextSection.COMPANY_CONTEXT_SECTION_COMPANY_GOALS:
      return "COMPANY_CONTEXT_SECTION_COMPANY_GOALS";
    case CompanyContextSection.COMPANY_CONTEXT_SECTION_ONBOARDING_BACKGROUND:
      return "COMPANY_CONTEXT_SECTION_ONBOARDING_BACKGROUND";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum CompanyContextSection");
  }
}

export interface IssueAttachmentMetadata {
  type: AttachmentType;
  issueId: string;
  scopeId: string;
  url: string;
  id?: string | undefined;
  humanReadableId: string;
}

export interface ExternalDocumentAttachmentMetadata {
  provider: ExternalDocumentProvider;
  providerDocumentId: string;
  title: string;
  url: string;
  parentTitle: string;
  mimeType: string;
  objectType: string;
  cloudId: string;
  spaceId: string;
  spaceKey: string;
  /**
   * Latest provider-reported update/edit timestamp observed for this document.
   * Used as a fallback for signal period filtering; codeup refreshes provider
   * metadata during signal materialization when provider credentials are
   * available.
   */
  providerUpdatedAt?: Date | undefined;
}

/** Message stored in the `details` JSON column of the Attachment table. */
export interface AttachmentDetails {
  id: string;
  companyId: number;
  projectId?: string | undefined;
  uploaderId: string;
  description: string;
  fileName?: string | undefined;
  originalFileName?: string | undefined;
  type: AttachmentType;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  fileSizeBytes: number;
  issue?: IssueAttachmentMetadata | undefined;
  userDescription?:
    | string
    | undefined;
  /** Public URL for image attachments (DO Spaces) */
  imageUrl?:
    | string
    | undefined;
  /** ID of the linked DB Document record (used when type = DOCUMENT_LINK) */
  sourceDocumentId?:
    | string
    | undefined;
  /** Normalized URL for URL-type attachments; used for deduplication. */
  sourceUrl?:
    | string
    | undefined;
  /**
   * Marker for workspace-scoped (project_id IS NULL) attachments added via
   * the integrations-v2 UI. New rows are written with the constant sentinel
   * "workspace"; legacy rows may carry an old bucket key (e.g.
   * "customer-feedback"). Any non-empty value means "workspace integration
   * attachment" — the value itself carries no meaning. Empty for
   * project-scoped attachments.
   */
  integrationBucket?:
    | string
    | undefined;
  /**
   * Background processing state. Undefined / UNKNOWN means the row predates
   * the background-intake flow and the UI should treat it as READY.
   */
  processingStatus?:
    | AttachmentProcessingStatus
    | undefined;
  /**
   * Human-readable reason for the most recent processing failure. Only
   * populated when processing_status == ATTACHMENT_FAILED.
   */
  failureReason?:
    | string
    | undefined;
  /**
   * Workspace chat that owns this attachment (intake/scoping). Mutually
   * exclusive with project_id in practice — once an attachment is copied to
   * a project during create, the per-project copy carries project_id and
   * chat_id is unset.
   */
  chatId?:
    | string
    | undefined;
  /**
   * Optional company context section this workspace attachment supports.
   * Used for onboarding/company-info attachments, e.g. "companyGoals" or
   * "onboardingBackground". Distinct from integration_bucket.
   */
  companyContextSection?:
    | CompanyContextSection
    | undefined;
  /**
   * System-authored explanation for why this attachment is linked. Distinct
   * from user_description, which is user-authored attachment context.
   */
  linkReason?:
    | string
    | undefined;
  /** Provider-backed document metadata for EXTERNAL_DOCUMENT attachments. */
  externalDocument?: ExternalDocumentAttachmentMetadata | undefined;
}

export interface AttachmentMeta {
  fileName: string;
  fileType: string;
  originalFileName: string;
  size: number;
  workspaceId?: string | undefined;
  userDescription?:
    | string
    | undefined;
  /** Public URL for image attachments (DO Spaces) */
  imageUrl?: string | undefined;
}

/**
 * Detected external link (before fetching preview data).
 * Represents a URL detected in text with its provider and identifier.
 */
export interface ExternalLink {
  /** The normalized URL */
  url: string;
  /** Link provider (e.g., "jira", "linear", "notion") */
  provider: string;
  /** Provider-specific identifier (e.g., issue key, doc ID) */
  identifier: string;
}

/**
 * Fetched preview data for an external link.
 * Contains the original link plus metadata fetched from the provider.
 */
export interface ExternalLinkPreview {
  /** The original detected link */
  link:
    | ExternalLink
    | undefined;
  /** Display title (issue summary, doc title, etc.) */
  title: string;
  /** Optional description or subtitle */
  description: string;
  /** Status label (e.g., "In Progress", "Done") */
  status: string;
  /** Structured metadata to create IssueAttachmentMetadata client-side. */
  issue?: IssueAttachmentMetadata | undefined;
}

function createBaseIssueAttachmentMetadata(): IssueAttachmentMetadata {
  return { type: 0, issueId: "", scopeId: "", url: "", id: undefined, humanReadableId: "" };
}

export const IssueAttachmentMetadata: MessageFns<IssueAttachmentMetadata> = {
  encode(message: IssueAttachmentMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.issueId !== "") {
      writer.uint32(18).string(message.issueId);
    }
    if (message.scopeId !== "") {
      writer.uint32(26).string(message.scopeId);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    if (message.id !== undefined) {
      writer.uint32(42).string(message.id);
    }
    if (message.humanReadableId !== "") {
      writer.uint32(50).string(message.humanReadableId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IssueAttachmentMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIssueAttachmentMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.issueId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scopeId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.humanReadableId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IssueAttachmentMetadata {
    return {
      type: isSet(object.type) ? attachmentTypeFromJSON(object.type) : 0,
      issueId: isSet(object.issueId)
        ? globalThis.String(object.issueId)
        : isSet(object.issue_id)
        ? globalThis.String(object.issue_id)
        : "",
      scopeId: isSet(object.scopeId)
        ? globalThis.String(object.scopeId)
        : isSet(object.scope_id)
        ? globalThis.String(object.scope_id)
        : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      humanReadableId: isSet(object.humanReadableId)
        ? globalThis.String(object.humanReadableId)
        : isSet(object.human_readable_id)
        ? globalThis.String(object.human_readable_id)
        : "",
    };
  },

  toJSON(message: IssueAttachmentMetadata): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = attachmentTypeToJSON(message.type);
    }
    if (message.issueId !== "") {
      obj.issueId = message.issueId;
    }
    if (message.scopeId !== "") {
      obj.scopeId = message.scopeId;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.humanReadableId !== "") {
      obj.humanReadableId = message.humanReadableId;
    }
    return obj;
  },

  create(base?: DeepPartial<IssueAttachmentMetadata>): IssueAttachmentMetadata {
    return IssueAttachmentMetadata.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IssueAttachmentMetadata>): IssueAttachmentMetadata {
    const message = createBaseIssueAttachmentMetadata();
    message.type = object.type ?? 0;
    message.issueId = object.issueId ?? "";
    message.scopeId = object.scopeId ?? "";
    message.url = object.url ?? "";
    message.id = object.id ?? undefined;
    message.humanReadableId = object.humanReadableId ?? "";
    return message;
  },
};

function createBaseExternalDocumentAttachmentMetadata(): ExternalDocumentAttachmentMetadata {
  return {
    provider: 0,
    providerDocumentId: "",
    title: "",
    url: "",
    parentTitle: "",
    mimeType: "",
    objectType: "",
    cloudId: "",
    spaceId: "",
    spaceKey: "",
    providerUpdatedAt: undefined,
  };
}

export const ExternalDocumentAttachmentMetadata: MessageFns<ExternalDocumentAttachmentMetadata> = {
  encode(message: ExternalDocumentAttachmentMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== 0) {
      writer.uint32(8).int32(message.provider);
    }
    if (message.providerDocumentId !== "") {
      writer.uint32(18).string(message.providerDocumentId);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.url !== "") {
      writer.uint32(34).string(message.url);
    }
    if (message.parentTitle !== "") {
      writer.uint32(42).string(message.parentTitle);
    }
    if (message.mimeType !== "") {
      writer.uint32(50).string(message.mimeType);
    }
    if (message.objectType !== "") {
      writer.uint32(58).string(message.objectType);
    }
    if (message.cloudId !== "") {
      writer.uint32(66).string(message.cloudId);
    }
    if (message.spaceId !== "") {
      writer.uint32(74).string(message.spaceId);
    }
    if (message.spaceKey !== "") {
      writer.uint32(82).string(message.spaceKey);
    }
    if (message.providerUpdatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.providerUpdatedAt), writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExternalDocumentAttachmentMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExternalDocumentAttachmentMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.providerDocumentId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.parentTitle = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.objectType = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.cloudId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.spaceId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.spaceKey = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.providerUpdatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExternalDocumentAttachmentMetadata {
    return {
      provider: isSet(object.provider) ? externalDocumentProviderFromJSON(object.provider) : 0,
      providerDocumentId: isSet(object.providerDocumentId)
        ? globalThis.String(object.providerDocumentId)
        : isSet(object.provider_document_id)
        ? globalThis.String(object.provider_document_id)
        : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      parentTitle: isSet(object.parentTitle)
        ? globalThis.String(object.parentTitle)
        : isSet(object.parent_title)
        ? globalThis.String(object.parent_title)
        : "",
      mimeType: isSet(object.mimeType)
        ? globalThis.String(object.mimeType)
        : isSet(object.mime_type)
        ? globalThis.String(object.mime_type)
        : "",
      objectType: isSet(object.objectType)
        ? globalThis.String(object.objectType)
        : isSet(object.object_type)
        ? globalThis.String(object.object_type)
        : "",
      cloudId: isSet(object.cloudId)
        ? globalThis.String(object.cloudId)
        : isSet(object.cloud_id)
        ? globalThis.String(object.cloud_id)
        : "",
      spaceId: isSet(object.spaceId)
        ? globalThis.String(object.spaceId)
        : isSet(object.space_id)
        ? globalThis.String(object.space_id)
        : "",
      spaceKey: isSet(object.spaceKey)
        ? globalThis.String(object.spaceKey)
        : isSet(object.space_key)
        ? globalThis.String(object.space_key)
        : "",
      providerUpdatedAt: isSet(object.providerUpdatedAt)
        ? fromJsonTimestamp(object.providerUpdatedAt)
        : isSet(object.provider_updated_at)
        ? fromJsonTimestamp(object.provider_updated_at)
        : undefined,
    };
  },

  toJSON(message: ExternalDocumentAttachmentMetadata): unknown {
    const obj: any = {};
    if (message.provider !== 0) {
      obj.provider = externalDocumentProviderToJSON(message.provider);
    }
    if (message.providerDocumentId !== "") {
      obj.providerDocumentId = message.providerDocumentId;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.parentTitle !== "") {
      obj.parentTitle = message.parentTitle;
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    if (message.objectType !== "") {
      obj.objectType = message.objectType;
    }
    if (message.cloudId !== "") {
      obj.cloudId = message.cloudId;
    }
    if (message.spaceId !== "") {
      obj.spaceId = message.spaceId;
    }
    if (message.spaceKey !== "") {
      obj.spaceKey = message.spaceKey;
    }
    if (message.providerUpdatedAt !== undefined) {
      obj.providerUpdatedAt = message.providerUpdatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<ExternalDocumentAttachmentMetadata>): ExternalDocumentAttachmentMetadata {
    return ExternalDocumentAttachmentMetadata.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ExternalDocumentAttachmentMetadata>): ExternalDocumentAttachmentMetadata {
    const message = createBaseExternalDocumentAttachmentMetadata();
    message.provider = object.provider ?? 0;
    message.providerDocumentId = object.providerDocumentId ?? "";
    message.title = object.title ?? "";
    message.url = object.url ?? "";
    message.parentTitle = object.parentTitle ?? "";
    message.mimeType = object.mimeType ?? "";
    message.objectType = object.objectType ?? "";
    message.cloudId = object.cloudId ?? "";
    message.spaceId = object.spaceId ?? "";
    message.spaceKey = object.spaceKey ?? "";
    message.providerUpdatedAt = object.providerUpdatedAt ?? undefined;
    return message;
  },
};

function createBaseAttachmentDetails(): AttachmentDetails {
  return {
    id: "",
    companyId: 0,
    projectId: undefined,
    uploaderId: "",
    description: "",
    fileName: undefined,
    originalFileName: undefined,
    type: 0,
    createdAt: undefined,
    updatedAt: undefined,
    fileSizeBytes: 0,
    issue: undefined,
    userDescription: undefined,
    imageUrl: undefined,
    sourceDocumentId: undefined,
    sourceUrl: undefined,
    integrationBucket: undefined,
    processingStatus: undefined,
    failureReason: undefined,
    chatId: undefined,
    companyContextSection: undefined,
    linkReason: undefined,
    externalDocument: undefined,
  };
}

export const AttachmentDetails: MessageFns<AttachmentDetails> = {
  encode(message: AttachmentDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.projectId !== undefined) {
      writer.uint32(26).string(message.projectId);
    }
    if (message.uploaderId !== "") {
      writer.uint32(34).string(message.uploaderId);
    }
    if (message.description !== "") {
      writer.uint32(42).string(message.description);
    }
    if (message.fileName !== undefined) {
      writer.uint32(50).string(message.fileName);
    }
    if (message.originalFileName !== undefined) {
      writer.uint32(58).string(message.originalFileName);
    }
    if (message.type !== 0) {
      writer.uint32(64).int32(message.type);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(74).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(82).fork()).join();
    }
    if (message.fileSizeBytes !== 0) {
      writer.uint32(88).int64(message.fileSizeBytes);
    }
    if (message.issue !== undefined) {
      IssueAttachmentMetadata.encode(message.issue, writer.uint32(98).fork()).join();
    }
    if (message.userDescription !== undefined) {
      writer.uint32(106).string(message.userDescription);
    }
    if (message.imageUrl !== undefined) {
      writer.uint32(114).string(message.imageUrl);
    }
    if (message.sourceDocumentId !== undefined) {
      writer.uint32(122).string(message.sourceDocumentId);
    }
    if (message.sourceUrl !== undefined) {
      writer.uint32(130).string(message.sourceUrl);
    }
    if (message.integrationBucket !== undefined) {
      writer.uint32(138).string(message.integrationBucket);
    }
    if (message.processingStatus !== undefined) {
      writer.uint32(144).int32(message.processingStatus);
    }
    if (message.failureReason !== undefined) {
      writer.uint32(154).string(message.failureReason);
    }
    if (message.chatId !== undefined) {
      writer.uint32(162).string(message.chatId);
    }
    if (message.companyContextSection !== undefined) {
      writer.uint32(168).int32(message.companyContextSection);
    }
    if (message.linkReason !== undefined) {
      writer.uint32(178).string(message.linkReason);
    }
    if (message.externalDocument !== undefined) {
      ExternalDocumentAttachmentMetadata.encode(message.externalDocument, writer.uint32(186).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachmentDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachmentDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.uploaderId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.originalFileName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.fileSizeBytes = longToNumber(reader.int64());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.issue = IssueAttachmentMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.userDescription = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.imageUrl = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.sourceDocumentId = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.sourceUrl = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.integrationBucket = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.processingStatus = reader.int32() as any;
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.failureReason = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.chatId = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.companyContextSection = reader.int32() as any;
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.linkReason = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.externalDocument = ExternalDocumentAttachmentMetadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachmentDetails {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
      uploaderId: isSet(object.uploaderId)
        ? globalThis.String(object.uploaderId)
        : isSet(object.uploader_id)
        ? globalThis.String(object.uploader_id)
        : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : undefined,
      originalFileName: isSet(object.originalFileName)
        ? globalThis.String(object.originalFileName)
        : isSet(object.original_file_name)
        ? globalThis.String(object.original_file_name)
        : undefined,
      type: isSet(object.type) ? attachmentTypeFromJSON(object.type) : 0,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      fileSizeBytes: isSet(object.fileSizeBytes)
        ? globalThis.Number(object.fileSizeBytes)
        : isSet(object.file_size_bytes)
        ? globalThis.Number(object.file_size_bytes)
        : 0,
      issue: isSet(object.issue) ? IssueAttachmentMetadata.fromJSON(object.issue) : undefined,
      userDescription: isSet(object.userDescription)
        ? globalThis.String(object.userDescription)
        : isSet(object.user_description)
        ? globalThis.String(object.user_description)
        : undefined,
      imageUrl: isSet(object.imageUrl)
        ? globalThis.String(object.imageUrl)
        : isSet(object.image_url)
        ? globalThis.String(object.image_url)
        : undefined,
      sourceDocumentId: isSet(object.sourceDocumentId)
        ? globalThis.String(object.sourceDocumentId)
        : isSet(object.source_document_id)
        ? globalThis.String(object.source_document_id)
        : undefined,
      sourceUrl: isSet(object.sourceUrl)
        ? globalThis.String(object.sourceUrl)
        : isSet(object.source_url)
        ? globalThis.String(object.source_url)
        : undefined,
      integrationBucket: isSet(object.integrationBucket)
        ? globalThis.String(object.integrationBucket)
        : isSet(object.integration_bucket)
        ? globalThis.String(object.integration_bucket)
        : undefined,
      processingStatus: isSet(object.processingStatus)
        ? attachmentProcessingStatusFromJSON(object.processingStatus)
        : isSet(object.processing_status)
        ? attachmentProcessingStatusFromJSON(object.processing_status)
        : undefined,
      failureReason: isSet(object.failureReason)
        ? globalThis.String(object.failureReason)
        : isSet(object.failure_reason)
        ? globalThis.String(object.failure_reason)
        : undefined,
      chatId: isSet(object.chatId)
        ? globalThis.String(object.chatId)
        : isSet(object.chat_id)
        ? globalThis.String(object.chat_id)
        : undefined,
      companyContextSection: isSet(object.companyContextSection)
        ? companyContextSectionFromJSON(object.companyContextSection)
        : isSet(object.company_context_section)
        ? companyContextSectionFromJSON(object.company_context_section)
        : undefined,
      linkReason: isSet(object.linkReason)
        ? globalThis.String(object.linkReason)
        : isSet(object.link_reason)
        ? globalThis.String(object.link_reason)
        : undefined,
      externalDocument: isSet(object.externalDocument)
        ? ExternalDocumentAttachmentMetadata.fromJSON(object.externalDocument)
        : isSet(object.external_document)
        ? ExternalDocumentAttachmentMetadata.fromJSON(object.external_document)
        : undefined,
    };
  },

  toJSON(message: AttachmentDetails): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    if (message.uploaderId !== "") {
      obj.uploaderId = message.uploaderId;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.fileName !== undefined) {
      obj.fileName = message.fileName;
    }
    if (message.originalFileName !== undefined) {
      obj.originalFileName = message.originalFileName;
    }
    if (message.type !== 0) {
      obj.type = attachmentTypeToJSON(message.type);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.fileSizeBytes !== 0) {
      obj.fileSizeBytes = Math.round(message.fileSizeBytes);
    }
    if (message.issue !== undefined) {
      obj.issue = IssueAttachmentMetadata.toJSON(message.issue);
    }
    if (message.userDescription !== undefined) {
      obj.userDescription = message.userDescription;
    }
    if (message.imageUrl !== undefined) {
      obj.imageUrl = message.imageUrl;
    }
    if (message.sourceDocumentId !== undefined) {
      obj.sourceDocumentId = message.sourceDocumentId;
    }
    if (message.sourceUrl !== undefined) {
      obj.sourceUrl = message.sourceUrl;
    }
    if (message.integrationBucket !== undefined) {
      obj.integrationBucket = message.integrationBucket;
    }
    if (message.processingStatus !== undefined) {
      obj.processingStatus = attachmentProcessingStatusToJSON(message.processingStatus);
    }
    if (message.failureReason !== undefined) {
      obj.failureReason = message.failureReason;
    }
    if (message.chatId !== undefined) {
      obj.chatId = message.chatId;
    }
    if (message.companyContextSection !== undefined) {
      obj.companyContextSection = companyContextSectionToJSON(message.companyContextSection);
    }
    if (message.linkReason !== undefined) {
      obj.linkReason = message.linkReason;
    }
    if (message.externalDocument !== undefined) {
      obj.externalDocument = ExternalDocumentAttachmentMetadata.toJSON(message.externalDocument);
    }
    return obj;
  },

  create(base?: DeepPartial<AttachmentDetails>): AttachmentDetails {
    return AttachmentDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachmentDetails>): AttachmentDetails {
    const message = createBaseAttachmentDetails();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    message.projectId = object.projectId ?? undefined;
    message.uploaderId = object.uploaderId ?? "";
    message.description = object.description ?? "";
    message.fileName = object.fileName ?? undefined;
    message.originalFileName = object.originalFileName ?? undefined;
    message.type = object.type ?? 0;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.fileSizeBytes = object.fileSizeBytes ?? 0;
    message.issue = (object.issue !== undefined && object.issue !== null)
      ? IssueAttachmentMetadata.fromPartial(object.issue)
      : undefined;
    message.userDescription = object.userDescription ?? undefined;
    message.imageUrl = object.imageUrl ?? undefined;
    message.sourceDocumentId = object.sourceDocumentId ?? undefined;
    message.sourceUrl = object.sourceUrl ?? undefined;
    message.integrationBucket = object.integrationBucket ?? undefined;
    message.processingStatus = object.processingStatus ?? undefined;
    message.failureReason = object.failureReason ?? undefined;
    message.chatId = object.chatId ?? undefined;
    message.companyContextSection = object.companyContextSection ?? undefined;
    message.linkReason = object.linkReason ?? undefined;
    message.externalDocument = (object.externalDocument !== undefined && object.externalDocument !== null)
      ? ExternalDocumentAttachmentMetadata.fromPartial(object.externalDocument)
      : undefined;
    return message;
  },
};

function createBaseAttachmentMeta(): AttachmentMeta {
  return {
    fileName: "",
    fileType: "",
    originalFileName: "",
    size: 0,
    workspaceId: undefined,
    userDescription: undefined,
    imageUrl: undefined,
  };
}

export const AttachmentMeta: MessageFns<AttachmentMeta> = {
  encode(message: AttachmentMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileName !== "") {
      writer.uint32(10).string(message.fileName);
    }
    if (message.fileType !== "") {
      writer.uint32(18).string(message.fileType);
    }
    if (message.originalFileName !== "") {
      writer.uint32(26).string(message.originalFileName);
    }
    if (message.size !== 0) {
      writer.uint32(32).int64(message.size);
    }
    if (message.workspaceId !== undefined) {
      writer.uint32(42).string(message.workspaceId);
    }
    if (message.userDescription !== undefined) {
      writer.uint32(50).string(message.userDescription);
    }
    if (message.imageUrl !== undefined) {
      writer.uint32(58).string(message.imageUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachmentMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachmentMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.originalFileName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.size = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.workspaceId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.userDescription = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.imageUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachmentMeta {
    return {
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : "",
      fileType: isSet(object.fileType)
        ? globalThis.String(object.fileType)
        : isSet(object.file_type)
        ? globalThis.String(object.file_type)
        : "",
      originalFileName: isSet(object.originalFileName)
        ? globalThis.String(object.originalFileName)
        : isSet(object.original_file_name)
        ? globalThis.String(object.original_file_name)
        : "",
      size: isSet(object.size) ? globalThis.Number(object.size) : 0,
      workspaceId: isSet(object.workspaceId)
        ? globalThis.String(object.workspaceId)
        : isSet(object.workspace_id)
        ? globalThis.String(object.workspace_id)
        : undefined,
      userDescription: isSet(object.userDescription)
        ? globalThis.String(object.userDescription)
        : isSet(object.user_description)
        ? globalThis.String(object.user_description)
        : undefined,
      imageUrl: isSet(object.imageUrl)
        ? globalThis.String(object.imageUrl)
        : isSet(object.image_url)
        ? globalThis.String(object.image_url)
        : undefined,
    };
  },

  toJSON(message: AttachmentMeta): unknown {
    const obj: any = {};
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.fileType !== "") {
      obj.fileType = message.fileType;
    }
    if (message.originalFileName !== "") {
      obj.originalFileName = message.originalFileName;
    }
    if (message.size !== 0) {
      obj.size = Math.round(message.size);
    }
    if (message.workspaceId !== undefined) {
      obj.workspaceId = message.workspaceId;
    }
    if (message.userDescription !== undefined) {
      obj.userDescription = message.userDescription;
    }
    if (message.imageUrl !== undefined) {
      obj.imageUrl = message.imageUrl;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachmentMeta>): AttachmentMeta {
    return AttachmentMeta.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachmentMeta>): AttachmentMeta {
    const message = createBaseAttachmentMeta();
    message.fileName = object.fileName ?? "";
    message.fileType = object.fileType ?? "";
    message.originalFileName = object.originalFileName ?? "";
    message.size = object.size ?? 0;
    message.workspaceId = object.workspaceId ?? undefined;
    message.userDescription = object.userDescription ?? undefined;
    message.imageUrl = object.imageUrl ?? undefined;
    return message;
  },
};

function createBaseExternalLink(): ExternalLink {
  return { url: "", provider: "", identifier: "" };
}

export const ExternalLink: MessageFns<ExternalLink> = {
  encode(message: ExternalLink, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.provider !== "") {
      writer.uint32(18).string(message.provider);
    }
    if (message.identifier !== "") {
      writer.uint32(26).string(message.identifier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExternalLink {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExternalLink();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.identifier = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExternalLink {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      identifier: isSet(object.identifier) ? globalThis.String(object.identifier) : "",
    };
  },

  toJSON(message: ExternalLink): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.identifier !== "") {
      obj.identifier = message.identifier;
    }
    return obj;
  },

  create(base?: DeepPartial<ExternalLink>): ExternalLink {
    return ExternalLink.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ExternalLink>): ExternalLink {
    const message = createBaseExternalLink();
    message.url = object.url ?? "";
    message.provider = object.provider ?? "";
    message.identifier = object.identifier ?? "";
    return message;
  },
};

function createBaseExternalLinkPreview(): ExternalLinkPreview {
  return { link: undefined, title: "", description: "", status: "", issue: undefined };
}

export const ExternalLinkPreview: MessageFns<ExternalLinkPreview> = {
  encode(message: ExternalLinkPreview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.link !== undefined) {
      ExternalLink.encode(message.link, writer.uint32(10).fork()).join();
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.status !== "") {
      writer.uint32(34).string(message.status);
    }
    if (message.issue !== undefined) {
      IssueAttachmentMetadata.encode(message.issue, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExternalLinkPreview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExternalLinkPreview();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.link = ExternalLink.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.issue = IssueAttachmentMetadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExternalLinkPreview {
    return {
      link: isSet(object.link) ? ExternalLink.fromJSON(object.link) : undefined,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      issue: isSet(object.issue) ? IssueAttachmentMetadata.fromJSON(object.issue) : undefined,
    };
  },

  toJSON(message: ExternalLinkPreview): unknown {
    const obj: any = {};
    if (message.link !== undefined) {
      obj.link = ExternalLink.toJSON(message.link);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.issue !== undefined) {
      obj.issue = IssueAttachmentMetadata.toJSON(message.issue);
    }
    return obj;
  },

  create(base?: DeepPartial<ExternalLinkPreview>): ExternalLinkPreview {
    return ExternalLinkPreview.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ExternalLinkPreview>): ExternalLinkPreview {
    const message = createBaseExternalLinkPreview();
    message.link = (object.link !== undefined && object.link !== null)
      ? ExternalLink.fromPartial(object.link)
      : undefined;
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.status = object.status ?? "";
    message.issue = (object.issue !== undefined && object.issue !== null)
      ? IssueAttachmentMetadata.fromPartial(object.issue)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
